(function () {
  'use strict';

  /* @ngdoc object
   * @name manageFlight
   * @description
   *
   */
  angular
    .module('manageFlight', [
      'ui.router'
    ]);
}());
